<template>
  <div>
    <div class="d-flex">
      <div class="mr-auto">
        <button class="btn btn-secondary" @click="refresh">
          <i class="fas fa-sync-alt fa-fw"></i>
        </button>
        <button class="btn btn-purple" v-if="canCreate" @click="onCreate">
          <i class="far fa-file fa-fw"></i>
        </button>
      </div>
      <div class="align-self-end">
        <input-debounced
            v-model="search"
            :clearable="true"
            :autofocus="true"
            placeholder="Search"
            class="search-bar w-300 mb-2"
        ></input-debounced>
      </div>
    </div>
    <base-table
        :base-url="urlWithFilters"
        ref="baseTable"
        @load-success="onLoadSuccess"
        @refresh="onRefresh"
        :current-page="currentPage"
        v-loading="isRefreshing"
        element-loading-spinner="el-icon-loading"
    >
      <template v-slot>
        <el-table
            :data="items"
            stripe
            class="w-100"
        >
          <el-table-column
              prop="model.id"
              label="Id"
              width="80"
          ></el-table-column>
          <el-table-column
              prop="model.to_address"
              label="To Address"
              min-width="120"
          ></el-table-column>
          <el-table-column
              prop="model.fallback_from"
              label="Fallback From"
              min-width="120"
          ></el-table-column>
          <el-table-column
              prop="model.fallback_to"
              label="Fallback To"
              min-width="120"
          ></el-table-column>
        </el-table>
      </template>
    </base-table>
    <el-pagination
        layout="prev, pager, next"
        :total="total"
        :current-page.sync="currentPage"
        :page-size="pageSize"
        class="text-right"
    ></el-pagination>
  </div>
</template>

<script>
import BaseTable from '../../../components/forwarding-address/table';

export default {
  extends: BaseTable,

  components: {
    // ...
  },

  props: {
    canCreate: Boolean,
    createUrl: String,
  },

  created() {
    eventBus.$on('refresh-forwarding-address-table', this.refresh);
  },

  beforeDestroy() {
    eventBus.$off('refresh-forwarding-address-table', this.refresh);
  }
}
</script>
